"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimDispenserControlHvPsOutValidation = void 0;
class SimDispenserControlHvPsOutValidation {
    static isValid(entity) {
        // If entity.output_voltage_v exists, validate that it has the correct type.
        if (entity.output_voltage_v != undefined) {
            if (typeof entity.output_voltage_v !== "number")
                return false;
        }
        // If entity.output_current_a exists, validate that it has the correct type.
        if (entity.output_current_a != undefined) {
            if (typeof entity.output_current_a !== "number")
                return false;
        }
        // If entity.faulted exists, validate that it has the correct type.
        if (entity.faulted != undefined) {
            if (typeof entity.faulted !== "boolean")
                return false;
        }
        return true;
    }
}
exports.SimDispenserControlHvPsOutValidation = SimDispenserControlHvPsOutValidation;
